<script>
    import Inputmask from "inputmask";
    import {VTextField} from 'vuetify/lib';

    export default {
        name: 'VHourMinuteField',
        extends: VTextField,
        mounted() {
            let input = this.$el.querySelector('input')
            if (input) {
                Inputmask("99:99", {
                    rightAlign: false,
                    placeholder: "oo:mm"
                }).mask(input);
            }
        }
    }
</script>
